import { type MouseEvent, useLayoutEffect, useRef, useState } from 'react'

import { type NavItemType } from '@/defs/nav'
import { cn } from '@/utils/commonUtil'

import styles from '../HeaderNav.module.scss'
import { HeaderNavButton } from '../HeaderNavButton/HeaderNavButton'
import { HeaderNavMenuInner } from '../HeaderNavMenuInner/HeaderNavMenuInner'

type Props = { item: NavItemType }

export const HeaderNavDropdown = ({ item }: Props) => {
  const [left, setLeft] = useState<number | undefined>(undefined)
  const [forceClose, setForceClose] = useState(false)
  const [isStuck, setIsStuck] = useState(false)
  const refMenu = useRef<HTMLUListElement | null>(null)
  const refItem = useRef<HTMLLIElement | null>(null)

  useLayoutEffect(() => {
    const onResize = () => {
      if (!refItem.current || !refMenu.current) return

      const positionItemCenter = refItem.current.getBoundingClientRect().left + refItem.current.offsetWidth / 2 - 24
      const centerMenu = refMenu.current.offsetWidth / 2

      if (positionItemCenter < centerMenu) setLeft(Math.ceil(centerMenu - positionItemCenter))
      else setLeft(undefined)
    }

    window.addEventListener('resize', onResize)
    onResize()

    return () => window.removeEventListener('resize', onResize)
  }, [])

  const onClickLink = () => {
    requestAnimationFrame(() => setForceClose(true))
  }

  const onMouseInteract = () => setForceClose(false)

  // First click sticks the dropdown open on focus, second click blurs to release it
  const onClickButton = (e: MouseEvent<HTMLElement>) => {
    if (isStuck) e.currentTarget.blur()
    setForceClose(isStuck)
    setIsStuck(!isStuck)
  }

  return (
    <li
      className={cn(styles.itemMain, { forceClose, styles })}
      onMouseEnter={onMouseInteract}
      onMouseLeave={onMouseInteract}
      ref={refItem}
    >
      <HeaderNavButton
        className={styles.buttonMain}
        item={item}
        onBlur={() => setIsStuck(false)}
        onClickLink={onClickButton}
        showCaret
      />
      {item.submenu && (
        <ul className={styles.menuDropdown} ref={refMenu} style={{ left: left ? `calc(50% + ${left}px)` : undefined }}>
          {item.submenu.map((itemSub) => (
            <li className={styles.itemDropdown} key={itemSub.id}>
              <HeaderNavButton className={styles.buttonInner} item={itemSub} onClickLink={onClickLink} />
              <HeaderNavMenuInner item={itemSub} onClickLink={onClickLink} />
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}
